// extracted by mini-css-extract-plugin
export default {"dropdown":"versionDropDown_dropdown__XSc47","verNoHeader":"versionDropDown_verNoHeader__VU1e-"};